import { useQuery } from "@tanstack/react-query";
import axios, { AxiosError } from "axios";
import { StatType } from "../types/stats";
import { usePermissionModal } from "../contexts/PermissionModalContext";

// Funções individuais para buscar cada estatística
const fetchFaturamentoDiario = async (): Promise<{ data: { data: StatType } }> => {
  return await axios.get("/api/dashboardStats/faturamento-diario");
};

const fetchFaturamentoMensal = async (): Promise<{ data: { data: StatType } }> => {
  return await axios.get("/api/dashboardStats/faturamento-mensal");
};

const fetchMargemLucro = async (): Promise<{ data: { data: StatType } }> => {
  return await axios.get("/api/dashboardStats/margem-lucro");
};

const fetchTicketMedio = async (): Promise<{ data: { data: StatType } }> => {
  return await axios.get("/api/dashboardStats/ticket-medio");
};

const fetchTotalVendas = async (): Promise<{ data: { data: StatType } }> => {
  return await axios.get("/api/dashboardStats/total-vendas");
};

const fetchItensVendidos = async (): Promise<{ data: { data: StatType } }> => {
  return await axios.get("/api/dashboardStats/itens-vendidos");
};

export const useFaturamentoDiario = () => {
  const { getQueryRetryHandler } = usePermissionModal();
  
  return useQuery<{ data: { data: StatType } }, AxiosError>({
    queryKey: ["faturamentoDiario"],
    queryFn: fetchFaturamentoDiario,
    retry: getQueryRetryHandler({
      queryKey: ["faturamentoDiario"],
      defaultMessage: "Você não possui permissão para visualizar o faturamento diário.",
      showModal: false // Não exibir modal, apenas esconder o componente
    }),
  });
};

export const useFaturamentoMensal = () => {
  const { getQueryRetryHandler } = usePermissionModal();
  
  return useQuery<{ data: { data: StatType } }, AxiosError>({
    queryKey: ["faturamentoMensal"],
    queryFn: fetchFaturamentoMensal,
    retry: getQueryRetryHandler({
      queryKey: ["faturamentoMensal"],
      defaultMessage: "Você não possui permissão para visualizar o faturamento mensal.",
      showModal: false // Não exibir modal, apenas esconder o componente
    }),
  });
};

export const useMargemLucro = () => {
  const { getQueryRetryHandler } = usePermissionModal();
  
  return useQuery<{ data: { data: StatType } }, AxiosError>({
    queryKey: ["margemLucro"],
    queryFn: fetchMargemLucro,
    retry: getQueryRetryHandler({
      queryKey: ["margemLucro"],
      defaultMessage: "Você não possui permissão para visualizar a margem de lucro.",
      showModal: false // Não exibir modal, apenas esconder o componente
    }),
  });
};

export const useTicketMedio = () => {
  const { getQueryRetryHandler } = usePermissionModal();
  
  return useQuery<{ data: { data: StatType } }, AxiosError>({
    queryKey: ["ticketMedio"],
    queryFn: fetchTicketMedio,
    retry: getQueryRetryHandler({
      queryKey: ["ticketMedio"],
      defaultMessage: "Você não possui permissão para visualizar o ticket médio.",
      showModal: false // Não exibir modal, apenas esconder o componente
    }),
  });
};

export const useTotalVendas = () => {
  const { getQueryRetryHandler } = usePermissionModal();

  return useQuery<{ data: { data: StatType } }, AxiosError>({
    queryKey: ["totalVendas"],
    queryFn: fetchTotalVendas,
    retry: getQueryRetryHandler({
      queryKey: ["totalVendas"],
      defaultMessage: "Você não possui permissão para visualizar o total de vendas.",
      showModal: false // Não exibir modal, apenas esconder o componente
    }),
  });
};

export const useItensVendidos = () => {
  const { getQueryRetryHandler } = usePermissionModal();

  return useQuery<{ data: { data: StatType } }, AxiosError>({
    queryKey: ["itensVendidos"],
    queryFn: fetchItensVendidos,
    retry: getQueryRetryHandler({
      queryKey: ["itensVendidos"],
      defaultMessage: "Você não possui permissão para visualizar os itens vendidos.",
      showModal: false
    }),
  });
};
